import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../translations/translations';

const statFade = {
    hidden: { opacity: 0, y: 16 },
    visible: (delay = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, delay, ease: [0.16, 1, 0.3, 1] },
    }),
};

const HeroStats = () => {
    const { language } = useLanguage();
    const t = useTranslation(language);

    const stats = [
        { value: t('heroStat1Value'), label: t('heroStat1Label') },
        { value: t('heroStat2Value'), label: t('heroStat2Label') },
        { value: t('heroStat3Value'), label: t('heroStat3Label') },
        { value: t('heroStat4Value'), label: t('heroStat4Label') },
    ];

    return (
        <div className="w-full">
            {stats.map((stat, index) => (
                <motion.div
                    key={stat.label}
                    initial="hidden"
                    animate="visible"
                    custom={0.5 + index * 0.08}
                    variants={statFade}
                    className="border-t border-white/10 py-6 first:border-t-0 lg:first:border-t lg:first:pt-0"
                >
                    <p className="text-xl md:text-2xl font-black text-white tracking-tight mb-1">
                        {stat.value}
                    </p>
                    <p className="text-xs font-mono text-white/40 tracking-widest uppercase">
                        {stat.label}
                    </p>
                </motion.div>
            ))}
        </div>
    );
};

export default HeroStats;
